module.exports = __webpack_public_path__ + "fonts/_Gotham-Bold.ec89e529.ttf";